import { selectPreviewRealtyIds } from './selectPreviewRealtyIds';
import { EFetchStatus } from '../../types/listingOffers';
import { IApplicationState } from '../../types/redux';

type TPreviewStatusSourceState = Parameters<typeof selectPreviewRealtyIds>[0] &
  Pick<IApplicationState, 'previewOffers'>;

/**
 * Что показывать в превью выбранного пина:
 * INITIAL - пин не выбран; SUCCESS - все объявления пина уже в хранилище превью, запроса могло и не быть;
 * иначе решает последний запрос: LOADING (идёт или ещё не начат), FAILURE (упал),
 * SUCCESS (бэк вернул не все объявления пина - показываем, что есть).
 */
export function selectPreviewOffersStatus(state: TPreviewStatusSourceState): EFetchStatus {
  const realtyIds = selectPreviewRealtyIds(state);

  if (realtyIds.length === 0) {
    return EFetchStatus.INITIAL;
  }

  const offerIdsInPreview = new Set(state.previewOffers.offers.map(offer => offer.id));
  const hasAllPinOffers = realtyIds.every(realtyId => offerIdsInPreview.has(realtyId));

  if (hasAllPinOffers) {
    return EFetchStatus.SUCCESS;
  }

  return state.previewOffers.status === EFetchStatus.INITIAL ? EFetchStatus.LOADING : state.previewOffers.status;
}
